<template>
  <div class="live-comment">
    <scroll class="scroll-wrapper" :pullUpLoad="true" @isPullingUp="isPullingUp" ref="scrollRef">
      <div class="content-wrapper">
        <div class="notice">
          <div class="notice-top">
            <span>当前公告</span>
            <span>历史公告</span>
          </div>
          <span class="notice-content">欢迎大家参加互动</span>
        </div>
        <div class="divider">
          <span class="divider-left"></span>
          <span class="divider-desc">全部留言</span>
          <span class="divider-left"></span>
        </div>
        <comment :commentList="commentList" />
      </div>
    </scroll>
  </div>
</template>

<script>
import Comment from "@/components/Base/Comment";
import Scroll from "@/components/Scroll/Scroll";
import { defineComponent, onMounted, ref } from "vue";
import { queryCommentWithoutStatusByPage } from "@/http/api";

export default defineComponent({
  name: "LivingComment",
  components: {
    Comment,
    Scroll
  },
  props: {
    programId: {
      type: Number
    }
  },
  setup(props) {
    const scrollRef = ref(null);
    const commentList = ref([]);
    const totalListPage = ref(0);
    let pages = 1;
    let rows = 10;

    const getCommentList = async () => {
      const { pageList, page, totalPage } = await queryCommentWithoutStatusByPage({
        operateType: 2,
        operateId: props.programId,
        page: pages,
        rows
      });
      totalListPage.value = totalPage;
      commentList.value = [...commentList.value, ...pageList];
    };

    const isPullingUp = async () => {
      if (pages >= totalListPage.value) {
        scrollRef.value.scroll.finishPullUp();
        return;
      }
      pages++;
      await getCommentList();
      scrollRef.value.scroll.finishPullUp();
    };

    onMounted(() => {
      getCommentList();
    });

    return {
      scrollRef,
      isPullingUp,
      commentList
    };
  }
});
</script>

<style lang="scss" scoped>
.live-comment {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  z-index: 9;
  overflow: hidden;

  .scroll-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;
    padding: 0 17px;
    overflow: hidden;

    .content-wrapper {
      width: 100%;
      min-height: calc(100% + 2px);

      .notice {
        width: 100%;
        margin-bottom: 20px;
        padding-top: 20px;

        .notice-top {
          display: flex;
          align-items: center;
          justify-content: space-between;

          & > span:first-child {
            color: #333;
            font-size: 16px;
          }

          & > span:last-child {
            color: #999;
            font-size: 12px;
          }
        }

        .notice-content {
          display: inline-block;
          margin-top: 10px;
          font-size: 14px;
          color: #666;
        }
      }

      .divider {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        margin-bottom: 15px;

        &-left {
          width: 100px;
          height: 1px;
          background: rgba(220, 220, 220, 0.9);
          transform: scaleY(0.5);
        }

        &-desc {
          margin: 0 15px;
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
